export default __webpack_public_path__ + "static/media/cross.b16fe7c1.png";